<template lang="pug">
  #ContactsIndex
    b-card.rounded-0(
      bg-variant="light",
      no-body
    )
      b-card-body.py-2.px-3
        h5.text-center 顧客通訊錄
        b-input-group.mb-2
          b-form-input(
            v-model="searchInput.nickName",
            placeholder="請輸入顧客Line暱稱"
          )
          b-input-group-append
            b-input-group-text(
              @click="searchHandler()"
            )
              i.fas.fa-search
        b-form-group.mb-2(
          label="綁定起始日："
        )
          b-input(
            v-model="searchInput.bindAt"
            type="date"
            placeholder="綁定起始日"
          )
        b-form-group.mb-2(
          label="綁定結束日："
        )
          b-input(
            v-model="searchInput.bindEnd"
            type="date"
            placeholder="綁定結束日"
          )
    .p-3
      b-card.border-0.mb-2.customerCard.overflow-hidden(
        bg-variant="light",
        v-for="(user,index) in contactsList",
        :key="user.id",
        @click="showUserInfoHandler(user.id)"
      )
        .row
          .col-1.d-flex.align-items-center.justify-content-center(
            v-show="selectMode"
          )
            b-form-checkbox(
              :id="`checkbox-group-${index}`",
              v-model="selectUsers",
              :name="`user-${index}`",
              :value="user.id",
              v-show="selectMode"
            )
          div(
            :class="{ 'col-11': selectMode, 'col-12': !selectMode }"
          )
            label.w-100.mb-0(
              :for="`checkbox-group-${index}`"
            )
              .row.align-items-center.border-bottom.pb-3.mb-3.no-gutters
                .col-6.pr-1
                  ProfilePhotoSticker.d-flex.align-items-center.justify-content-center.border.border-black(
                    :profileUrl="user.img",
                    :style="{ 'width': '80px', 'height': '80px' }"
                  )
                .col-6.pl-1
                  p.mb-0.font-weight-bold 暱稱名 {{ user.name }}
                  p.mb-0 備註名 {{ user.nick_name }}
              .reserveAtRow.mb-2.d-flex.align-items-center
                i.far.fa-calendar-check.mr-2
                small 預約時間：{{ user.bind_at }}
              .labelRow.d-flex.align-items-center.flex-wrap.mb-3
                i.fas.fa-tag.mr-2
                small 顧客標籤：
                b-badge.m-1.rounded-50.px-3.py-2(
                  variant="primary",
                  v-for="label in user.labels"
                  :key="label.id"
                ) {{ label.label }}
    //- 群發訊息按鈕
    .button-fixedArea
      b-button.rounded-50.d-flex.align-items-center.justify-content-center.button.iconBtn.iconPushBtn(
        variant="primary",
        @click="selectUserhHandler(true)"
      )
        i.fas.fa-volume-up.iconPush
      small.d-block.w-100.text-center 群發訊息
      b-button.rounded-50.d-flex.align-items-center.justify-content-center.button.button-close.iconBtn.iconPushBtn(
        variant="gray",
        v-if="selectMode",
        @click="selectUserhHandler(false)"
      )
        i.fas.fa-times
      b-badge.rounded-50.d-flex.align-items-center.justify-content-center.button.button-people.iconBtn.iconPushBtn.p-1(
        pill,
        variant="danger",
        v-if="selectMode"
      )
        span {{ selectUsers.length }}
</template>

<script>
import ProfilePhotoSticker from '@/components/profilePhotoSticker/ProfilePhotoStickerComponent.vue';
import { SM_CHAT_ROOM_INDEX } from '@/router/sm/chat-room';
import { SM_MY_CUSTOMER_INDEX } from '@/router/sm/my-customer';

// 測試圖片
import userExOneUrl from '@/assets/images/example/sa_1.png';
import userExTwoUrl from '@/assets/images/example/sa_2.png';
import userExThreeUrl from '@/assets/images/default/defaultImg.png';

const moment = require('moment');

export default {
  name: 'ContactsIndex',
  components: {
    ProfilePhotoSticker
  },
  data() {
    return {
      searchInput: {
        nickName: null,
        bindAt: null,
        bindEnd: null
      },
      contactsList: [
        {
          id: 0,
          name: 'Patty',
          nick_name: '小白兔',
          img: userExOneUrl,
          bind_at: '2020/06/29 18:30',
          labels: [
            {
              id: 0,
              label: '美白'
            },
            {
              id: 1,
              label: 'VIP'
            }
          ]
        },
        {
          id: 1,
          name: 'LuLu',
          nick_name: '超想白大戶',
          img: userExTwoUrl,
          bind_at: '2020/06/25 11:30',
          labels: [
            {
              id: 1,
              label: 'VIP'
            }
          ]
        },
        {
          id: 2,
          name: 'Ariby',
          nick_name: '中實戶',
          img: userExThreeUrl,
          bind_at: '2020/02/12 08:00',
          labels: [
            {
              id: 1,
              label: '難搞客戶'
            }
          ]
        }
      ],
      selectMode: false,
      selectUsers: []
    };
  },
  mounted() {
    this.$store.commit('toggleLoading', false);
  },
  methods: {
    searchHandler() {
      const vm = this;
      if (vm.searchInput.bindAt && vm.searchInput.bindEnd) {
        const momentBindAt = moment(vm.searchInput.bindAt).format();
        const momentBindEnd = moment(vm.searchInput.bindEnd).format();
        if (moment(momentBindEnd).isBefore(momentBindAt)) {
          vm.$swal.fire({
            icon: 'error',
            title: '綁定結束日不可小於綁定起始日'
          });
        }
      }
    },
    selectUserhHandler(mode) {
      // TODO: 顧客通訊錄的顧客群發
      console.log('群發');
      const vm = this;
      // 如果是點推播按鈕且目前在選擇使用者模式
      if (mode && vm.selectMode) {
        vm.$router.push({
          name: SM_CHAT_ROOM_INDEX
        });
      }
      vm.selectUser = [];
      vm.selectMode = mode;
    },
    showUserInfoHandler(userId) {
      console.log('顯示使用者詳細資訊');
      const vm = this;
      if (vm.selectMode) return;
      vm.$swal.fire({
        title: '載入中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });

      setTimeout(() => {
        vm.$swal.close();
        vm.$router.push({
          name: SM_MY_CUSTOMER_INDEX,
          params: {
            userId
          }
        }).catch(() => {});
      }, 2000);
    }
  }
};
</script>

<style>

</style>
